import React, { useState, useEffect, useCallback, Fragment } from "react";
import MerchantInitial from "./MerchantInitial";
import MerchantGuidlines from "./MerchantGuidelines";
import MerchantVAC from "./MerchantVAC";
import MerchantFAQ from "./MerchantFAQ";
import MerchantAgreement from "./MerchantAgreement";
const TabPanel = ({ index, value, children }) => {
	return (
		<Fragment>
			{index === value && <Fragment>{children}</Fragment>}
		</Fragment>
	);
};

const MerchantTabs = ({ close_modal }) => {
	const [index, setIndex] = useState(0);
	useEffect(
		() => {
			if (index === 5) {
				close_modal();
			}
			const modal = document.querySelector(".custom-modal");
			if (modal) {
				modal.scrollIntoView({ behavior: "smooth" });
			}
		},
		[index]
	);
	const next = useCallback(
		() => {
			if (index < 5) {
				setIndex((prev) => prev + 1);
			}
		},
		[index]
	);
	const previous = useCallback(
		() => {
			if (index > 0) {
				setIndex((prev) => prev - 1);
			}
		},
		[index]
	);
	return (
		<Fragment>
			<TabPanel value={0} index={index}>
				<MerchantInitial next={next} />
			</TabPanel>
			<TabPanel value={1} index={index}>
				<MerchantGuidlines next={next} previous={previous} />
			</TabPanel>
			<TabPanel value={2} index={index}>
				<MerchantVAC next={next} previous={previous} />
			</TabPanel>
			<TabPanel value={3} index={index}>
				<MerchantFAQ next={next} previous={previous} />
			</TabPanel>
			<TabPanel value={4} index={index}>
				<MerchantAgreement next={next} previous={previous} />
			</TabPanel>
		</Fragment>
	);
};

export default MerchantTabs;
